exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "approve .cover {\n  background: rgba(0, 0, 0, 0.5);\n  left: 0;\n  top: 0;\n  z-index: 1000;\n}\napprove .modal {\n  display: block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js??ref--1-2!./client/assets/scripts/modules/reservations/approve/styles.less
// module id = 310
// module chunks = 1